import PropTypes from 'prop-types';

export default {
  routeId: PropTypes.oneOfType([ PropTypes.string, PropTypes.number ]),
  routes: PropTypes.arrayOf(PropTypes.object),
  general: PropTypes.object,
  getPassengerDetails: PropTypes.func,
  selectedRoute: PropTypes.object,
  selectedTrip: PropTypes.object,
  toggleRoutes: PropTypes.func,
  showDate: PropTypes.bool,
  classes: PropTypes.object,
};



// WEBPACK FOOTER //
// ./src/containers/passengers/mobile/PassengersMobileProps.js